type EdgeIconProps = {
  className?: string;
  fill?: string;
};

export const DeliveryTruck = ({
  className,
}: EdgeIconProps): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 20.694 13.597"
  >
    <g id="Group_2634" data-name="Group 2634" transform="translate(0 0)">
      <path
        id="Path_349"
        data-name="Path 349"
        d="M7.83,104.824a1.837,1.837,0,1,1-1.836-1.879,1.859,1.859,0,0,1,1.836,1.879Zm-.918,0a.918.918,0,1,0-.918.939.929.929,0,0,0,.918-.939Zm-2.5-1.879H.3a.3.3,0,0,0-.3.3v.916a.3.3,0,0,0,.3.3H3.6a2.494,2.494,0,0,1,.816-1.517Zm13.03,1.879a1.837,1.837,0,1,1-1.836-1.879,1.859,1.859,0,0,1,1.836,1.879Zm-.918,0a.918.918,0,1,0-.918.939.929.929,0,0,0,.918-.939Zm4.165-1.577v.916a.3.3,0,0,1-.3.3H18a2.417,2.417,0,0,0-4.8,0H8.394a2.494,2.494,0,0,0-.817-1.517h4.559V94.307a.6.6,0,0,1,.591-.607h2.787a2.348,2.348,0,0,1,1.958,1.064l1.8,2.721a2.454,2.454,0,0,1,.4,1.352v4.1h.718a.3.3,0,0,1,.3.309ZM17.7,97.562,16.26,95.474a.293.293,0,0,0-.242-.128H13.775a.3.3,0,0,0-.3.3v2.088a.3.3,0,0,0,.3.3h3.678a.3.3,0,0,0,.245-.478Z"
        transform="translate(0 -93.023)"
      />
      <path
        id="Union_17"
        data-name="Union 17"
        d="M.607,9.1A.607.607,0,0,1,0,8.495V.607A.607.607,0,0,1,.607,0h9.911a.607.607,0,0,1,.607.607V8.495a.607.607,0,0,1-.607.607Zm.4-7.483V7.483a.607.607,0,0,0,.189.44l8.768-6.7a.607.607,0,0,0-.462-.214H1.618a.607.607,0,0,0-.607.607Z"
        transform="translate(0 0)"
      />
    </g>
  </svg>
);
